<div class="no-templates">
  <img [src]="noTemplateUrl" />
  <p>
    <span class="title">Create your masterpiece</span>
    <br />
    <span class="subtitle">Add a new template to get started</span>
  </p>
</div>
